import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=117cfab9&"
import script from "./EmailVerification.vue?vue&type=script&lang=ts&"
export * from "./EmailVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports